import React from 'react';
import { EmailVerificationCode as InnerField } from '@common/components/Account/components/EmailVerificationCode';
import { useAccountRules } from '@common/components/Account/rules/useAccountRules';
import { useTranslation } from '@common/hooks/useTranslation';
import { FieldWrapper } from '../FieldWrapper';

export const EmailVerificationCode = () => {
  const { t } = useTranslation();
  const { emailVerificationCodeRules } = useAccountRules();
  return (
    <FieldWrapper<string>
      name="emailVerificationCode"
      rules={emailVerificationCodeRules}
      render={(props) => {
        const mergedProps = { ...props, t };
        return <InnerField {...mergedProps} />;
      }}
    />
  );
};
